import { Grid, InputAdornment, SelectChangeEvent, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { memo, ReactElement } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { FormMetricVM } from '.';
import ListTypeRegister from 'practice/components/shared/list-type-register';
import ListTypePractice from 'practice/components/shared/list-type-practice';
import StateList from 'practice/components/shared/state-list';
import { DatePicker } from '@mui/lab';
import ListTypeOperation from '../shared/list-type-operation';

interface FormTypePracticeProps {
  disabled?: boolean;
  isEdit?: boolean;
  values?: FormMetricVM;
  onChange: (key: keyof FormMetricVM, value: FormMetricVM[keyof FormMetricVM]) => void;
  errors: FormikErrors<FormMetricVM> | undefined;
  touched: FormikTouched<FormMetricVM> | undefined;
}

const FormTypePracticeComponent = ({
  disabled,
  values,
  onChange,
  isEdit,
  touched,
  errors,
}: FormTypePracticeProps): ReactElement => {
  const handleListTypeRegisterChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('register', event.target.value);
  });

  const handleListTypePracticeChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('practice', event.target.value);
  });

  const handleListTypeOperationChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('operation', event.target.value);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={5}>
        <ListTypeRegister
          value={values?.register || ''}
          onChange={handleListTypeRegisterChange}
          error={touched?.register && Boolean(errors?.register)}
          required
          disabled={disabled || isEdit}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <ListTypePractice
          value={values?.practice || ''}
          disabled={disabled || isEdit}
          onChange={handleListTypePracticeChange}
          error={touched?.practice && Boolean(errors?.practice)}
          required
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <ListTypeOperation
          value={values?.operation || ''}
          onChange={handleListTypeOperationChange}
          tyPractice={values?.practice || ''}
          disabled={disabled || isEdit}
          error={touched?.operation && Boolean(errors?.operation)}
          required
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <StateList
          label="Stato pratica"
          value={values?.state || ''}
          disabled={disabled || isEdit}
          onChange={(value) => onChange('state', value)}
          error={touched?.state && Boolean(errors?.state)}
          required
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Periodo di attivazione della metrica Dal *"
          aria-label="Periodo di attivazione della metrica Dal"
          disabled={disabled || isEdit}
          value={values?.validityFrom || null}
          onChange={(value) => onChange('validityFrom', value)}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="validityFrom"
              helperText={errors?.validityFrom}
              error={touched?.validityFrom && Boolean(errors?.validityFrom)}
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Periodo di attivazione della metrica Al *"
          aria-label="Periodo di attivazione della metrica Al"
          value={values?.validityTo || null}
          onChange={(value) => onChange('validityTo', value)}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="validityTo"
              helperText={errors?.validityTo}
              error={touched?.validityTo && Boolean(errors?.validityTo)}
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Nr. max ore per operazione"
          label="Nr. max ore per operazione *"
          id="hoursMax"
          name="hoursMax"
          fullWidth
          type="number"
          InputProps={{
            endAdornment: <InputAdornment position="end">h</InputAdornment>,
          }}
          variant="outlined"
          value={values?.hoursMax || 0}
          onChange={(event) => onChange('hoursMax', event.target.value)}
          disabled={disabled}
          helperText={errors?.hoursMax}
          error={touched?.hoursMax && Boolean(errors?.hoursMax)}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Nr. ore per warning"
          label="Nr. ore per warning *"
          id="hoursWarning"
          name="hoursWarning"
          fullWidth
          type="number"
          variant="outlined"
          InputProps={{
            endAdornment: <InputAdornment position="end">h</InputAdornment>,
          }}
          value={values?.hoursWarning || 0}
          onChange={(event) => onChange('hoursWarning', event.target.value)}
          disabled={disabled}
          helperText={errors?.hoursWarning}
          error={touched?.hoursWarning && Boolean(errors?.hoursWarning)}
        />
      </Grid>
    </Grid>
  );
};

FormTypePracticeComponent.displayName = 'Form Type Practice Page component';

const FormTypePractice = memo(FormTypePracticeComponent);

export default FormTypePractice;
